export const getSection = ({ sectionName, data }) => {
	if (!data || !sectionName || !data.fields) return {}
	const section = data.fields.landingSections.find(
		section => section.sys.contentType.sys.id === sectionName
	)

	return section.fields
}
